'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import styles from './ShowPosterGrid.module.scss';

import { ShowDetails, ShowRowContent } from '@/lib/types/api/show-data';

import ShowPoster, { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';
import { ShowNode } from '@/lib/types/graphql/searchShowsResponse';

export interface ShowPosterGridProps {
  shows: ShowDetails[] | ShowRowContent[] | ShowNode[]
  showBadgeFlags?: ShowBadgeFlags;
}

export default function ShowPosterGrid(props: ShowPosterGridProps) {
  const { shows, showBadgeFlags } = props

  return (
    <div className={styles.show_poster_grid} data-sentry-component="ShowPosterGrid" data-sentry-source-file="ShowPosterGrid.tsx">
      {shows.map((show, i: number) => {
        return (
          <ShowPoster key={i} show={show} showBadgeFlags={showBadgeFlags} />
        )
      })}
    </div>
  )
}
